exports = module.exports = require("../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-simulator-screen [data-setter-prop]{line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/core/overlay/InPlaceEditing.less
// module id = 250
// module chunks = 0